/* import __COLOCATED_TEMPLATE__ from './confirm-deactivation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();